const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const TOOLTIP = 'Encapsulate some action element or data view';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField('  Icon Name:').appendField(new Blockly.FieldTextInput(''), 'iconName');
    blocklyBlock.appendStatementInput('children').appendField('Children:', 'childrenField');
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['iconName']);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
